export default __webpack_public_path__ + "static/media/testimonial-icon-png-7-Transparent-Images.b71cc388.png";